import 'zone.js';

import { APP_BASE_HREF, CurrencyPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { GlobalErrorHandler } from '@error-handlers/global-error-handler';
import { MapMarkerService, NgFindalabModule } from '@Medology/ng-findalab';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { FakeBackendInterceptor } from './app/interceptors/fake-backend.interceptor';
import { ConsultationRequestServiceProvider } from './app/providers/consultation.service.provider';
import { OrderServiceProvider } from './app/providers/order.service.provider';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      NgFindalabModule,
      ReactiveFormsModule,
      NgxMaskDirective,
      NgxMaskPipe,
    ),
    provideNgxMask(),
    MapMarkerService,
    CurrencyPipe,
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    OrderServiceProvider,
    ConsultationRequestServiceProvider,
  ],
}).catch((err) => console.error(err));
